export enum DefaultBottomBarOptions {
  RESIZE = 'resize',
  ANIMATION = 'animation',
  BACKGROUND = 'background',
  TITLE = 'title',
  GRID = 'grid',
  FOLDS = 'folds',
  BLEED = 'bleed',
  GUIDES = 'guides',
  // SUPER USER OPTIONS
  ITEMS_LIST = 'ITEMS_LIST',
  POSTER_TOOLS = 'POSTER_TOOLS',
  TEST_FUNCTION = 'TEST_FUNCTION',
}

export enum VideoItemBottomBarOptions {
  AI_SUBTITLES = 'ai-subtitles',
  POSITION = 'position',
  TRIM = 'trim',
  UNMUTE = 'unmute',
  DUPLICATE = 'duplicate',
  EFFECTS = 'effects',
  FILTER = 'filter',
  ADJUSTMENTS = 'adjustments',
  REPLACE = 'replace',
  FLIP = 'flip',
  STRETCH = 'stretch',
  COPY_STYLES = 'copy_styles',
  OPACITY = 'opacity',
  ANIMATION = 'animation',
  HYPERLINK = 'hyperlink',
  LOCK = 'lock',
  DELETE = 'delete',
  REMOVE_BG = 'remove-bg',
  VOLUME = 'volume',
}

export enum ElementItemBottomBarOptions {
  POSITION = 'position',
  FIll = 'fill',
  OUTLINE = 'outline',
  DUPLICATE = 'duplicate',
  SHADOW = 'shadow',
  FLIP = 'flip',
  STRETCH = 'stretch',
  COPY_STYLES = 'copy_styles',
  HYPERLINK = 'hyperlink',
  OPACITY = 'opacity',
  ANIMATION = 'animation',
  LOCK = 'lock',
  DELETE = 'delete',
}

export enum UniqueRectangleItemBottomBarOptions {
  ROUNDNESS = 'roundness',
}

export enum TextSlideBottomBarOptions {
  EDIT = 'edit',
  POSITION = 'position',
  SLIDES = 'slides',
  FONT = 'font',
  TRANSITION = 'transition',
  SIZE = 'size',
  STYLE = 'style',
  DUPLICATE = 'duplicate',
  FILL = 'fill',
  OUTLINE = 'outline',
  ALIGNMENT = 'alignment',
  LETTER_SPACING = 'letter-spacing',
  LINE_HEIGHT = 'line-height',
  LISTS = 'lists',
  BACKGROUND = 'background',
  SHADOW = 'shadow',
  FLIP = 'flip',
  STRETCH = 'stretch',
  SPELLCHECK = 'spellcheck',
  COPY_STYLES = 'copy_styles',
  HYPERLINK = 'hyperlink',
  OPACITY = 'opacity',
  ANIMATION = 'animation',
  APPLY_TO_ALL = 'apply_to_all',
  LOCK = 'lock',
  DELETE = 'delete',
}
export enum TextItemBottomBarOptions {
  EDIT = 'edit',
  TEXT = 'TEXT',
  POSITION = 'position',
  FONT = 'font',
  SIZE = 'size',
  STYLE = 'style',
  DUPLICATE = 'duplicate',
  FILL = 'fill',
  OUTLINE = 'outline',
  ALIGNMENT = 'alignment',
  LETTER_SPACING = 'letter-spacing',
  LINE_HEIGHT = 'line-height',
  LISTS = 'lists',
  BACKGROUND = 'background',
  SHADOW = 'shadow',
  ANIMATION = 'animation',
  SPELLCHECK = 'spellcheck',
  COPY_STYLES = 'copy_styles',
  HYPERLINK = 'hyperlink',
  OPACTIY = 'opacity',
  LOCK = 'lock',
  DELETE = 'delete',
}

export enum TabItemBottomBarOptions {
  POSITION = 'position',
  NUM_OF_TABS = 'num-of-tabs',
  TEXT = 'TEXT',
  FONT = 'font',
  STYLE = 'style',
  DUPLICATE = 'duplicate',
  FILL = 'fill',
  OUTLINE = 'outline',
  ALIGNMENT = 'alignment',
  LETTER_SPACING = 'letter-spacing',
  LINE_HEIGHT = 'line-height',
  BACKGROUND = 'background',
  SEPERATOR = 'seperator',
  COPY_STYLES = 'copy_styles',
  HYPERLINK = 'hyperlink',
  OPACITY = 'opacity',
  ANIMATION = 'animation',
  LOCK = 'lock',
  DELETE = 'delete',
}

export enum TableItemBottomBarOptions {
  POSITION = 'position',
  CONTENT = 'content',
  LAYOUT = 'layout',
  FONT = 'font',
  STYLE = 'style',
  FONT_TWO = 'font_two',
  STYLE_TWO = 'style_two',
  SIZE = 'size',
  DUPLICATE = 'duplicate',
  FILL_DUAL_FONTS = 'fill_dual_fonts',
  FILL_SINGLE_FONT = 'fill_single_font',
  OUTLINE = 'outline',
  ALIGNMENT = 'alignment',
  SPACING = 'spacing',
  LETTER_SPACING = 'letter_spacing',
  LINE_HEIGHT = 'line_height',
  BACKGROUND = 'background',
  BORDER = 'border',
  DATE_OR_HIGHLIGHTED_STYLES = 'date_or_highlighted_styles',
  COPY_STYLES = 'copy_styles',
  HYPERLINK = 'hyperlink',
  OPACITY = 'opacity',
  ANIMATION = 'animation',
  LOCK = 'lock',
  DELETE = 'delete',
}

export enum StickerItemBottomBarOptions {
  POSITION = 'position',
  DUPLICATE = 'duplicate',
  FILTERS = 'filters',
  EFFECTS = 'effect',
  ADJUSTMENTS = 'adjustments',
  FLIP = 'flip',
  STRETCH = 'stretch',
  COPY_STYLES = 'copy_styles',
  HYPERLINK = 'hyperlink',
  OPACITY = 'opacity',
  ANIMATION = 'animation',
  LOCK = 'lock',
  DELETE = 'delete',
}
export enum QRItemBottomBarOptions {
  POSITION = 'position',
  QR_CONTENT = 'qr-content',
  COLOR = 'color',
  BACKGROUND = 'background',
  DUPLICATE = 'duplicate',
  FLIP = 'flip',
  STRETCH = 'stretch',
  COPY_STYLES = 'copy_styles',
  OPACITY = 'opacity',
  ANIMATION = 'animation',
  LOCK = 'lock',
  DELETE = 'delete',
}

export enum MenuItemBottomBarOptions {
  POSITION = 'position',
  CONTENT = 'content',
  LAYOUT = 'layout',
  FONT_1 = 'font-1',
  STYLE_1 = 'style-1',
  FONT_2 = 'font-2',
  STYLE_2 = 'style-2',
  SIZE = 'size',
  DUPLICATE = 'duplicate',
  FILL = 'fill',
  OUTLINE = 'outline',
  SPACING = 'spacing',
  LINE_HEIGHT = 'line_height',
  LETTER_SPACING = 'letter_spacing',
  BACKGROUND = 'background',
  BORDER = 'border',
  ICON_STYLES = 'icon-styles',
  COPY_STYLES = 'copy_styles',
  HYPERLINK = 'hyperlink',
  OPACITY = 'opacity',
  ANIMATION = 'animation',
  LOCK = 'lock',
  DELETE = 'delete',
}

export enum MediaSlideBottomBarOptions {
  POSITION = 'position',
  SLIDES = 'slides',
  CROP = 'crop',
  TRIM = 'trim',
  UNMUTE = 'unmute',
  VOLUME = 'volume',
  TRANSITION = 'transition',
  REMOVE_BG = 'remove-bg',
  DUPLICATE = 'duplicate',
  MASK = 'mask',
  ALIGNMENT = 'alignment',
  FILTERS = 'filters',
  EFFECTS = 'effect',
  ADJUSTMENTS = 'adjustments',
  REPLACE = 'replace',
  FLIP = 'flip',
  STRETCH = 'stretch',
  COPY_STYLES = 'copy_styles',
  HYPERLINK = 'hyperlink',
  ANIMATION = 'animation',
  OPACITY = 'opacity',
  APPLY_TO_ALL = 'apply_to_all',
  LOCK = 'lock',
  DELETE = 'delete',
  ROUNDNESS = 'roundness',
}

export enum ImageItemBottomBarOptions {
  POSITION = 'position',
  DRAW_COLOR = 'DRAW_COLOR',
  CROP = 'crop',
  REMOVE_BG = 'remove-bg',
  DUPLICATE = 'duplicate',
  MASK = 'mask',
  FILTERS = 'filters',
  EFFECTS = 'effect',
  ADJUSTMENTS = 'adjustments',
  REPLACE = 'replace',
  FLIP = 'flip',
  STRETCH = 'stretch',
  COPY_STYLES = 'copy_styles',
  HYPERLINK = 'hyperlink',
  OPACITY = 'opacity',
  ANIMATION = 'animation',
  LOCK = 'lock',
  DELETE = 'delete',
  ROUNDNESS = 'roundness',
}

export enum FancyTextItemBottomBarOptions {
  TEXT = 'text',
  POSITION = 'position',
  EFFECT = 'effect',
  FONT = 'font',
  DUPLICATE = 'duplicate',
  COLORS = 'colors',
  TEXT_SHAPE = 'text_shape',
  SHADOW = 'shadow',
  FLIP = 'flip',
  STRETCH = 'stretch',
  COPY_STYLES = 'copy_styles',
  HYPERLINK = 'hyperlink',
  OPACTIY = 'opacity',
  ANIMATION = 'animation',
  LOCK = 'lock',
  DELETE = 'delete',
}

export enum DrawBottomBar {
  BRUSH = 'BRUSH',
  ERASER = 'ERASER',
  COLOR = 'COLOR',
  BRUSH_SIZE = 'BRUSH_SIZE',
}

export enum TranscriptItemBottomBarOptions {
  SUBTITLES = 'subtitles',
  PRESETS = 'presets',
  FONT = 'font',
  SIZE = 'size',
  SENTENCE_FILL = 'sentence-fill',
  SENTENCE_OUTLINE = 'sentence-outline',
  ALIGNMENT = 'alignment',
  LETTER_SPACING = 'letter-spacing',
  LETTER_CASE = 'letter-case',
  BACKGROUND = 'background',
  SHADOW = 'shadow',
  POSITION = 'position',
  DUPLICATE = 'duplicate',
  LOCK = 'lock',
  DELETE = 'delete',
  COPY_STYLES = 'copy_styles',

  HIGHLIGHT_WORD = 'highlight-word',
}
